import { ExportsCardId } from '../enums/exportsCardId'
import { ExportCardVisibilityConditions, exportCardVisibilityRules } from './exportsCardVisibilityRules'

interface IsExportCardVisibleArgs {
  exportCardVisibilityConditions: ExportCardVisibilityConditions
  id: ExportsCardId
}

export const isExportCardVisible = ({ exportCardVisibilityConditions, id }: IsExportCardVisibleArgs) => {
  const rule = exportCardVisibilityRules[id]
  return rule ? rule(exportCardVisibilityConditions) : true
}
